import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export const PWAUpdatePrompt: React.FC = () => {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, r) {
      if (!r) return;
      // iOS standalone PWAs don't reliably fire visibilitychange on app resume,
      // so we combine both strategies to ensure update detection works.
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) r.update();
      });
      // Fallback poll every 5 minutes (catches cases where visibilitychange doesn't fire)
      setInterval(() => r.update(), 5 * 60 * 1000);
    },
  });

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-[calc(env(safe-area-inset-top,0px)+0.5rem)] left-0 right-0 z-[100] flex justify-center px-4"
    >
      <div className="bg-neutral-900 border-2 border-primary shadow-lg rounded-lg px-4 py-3 flex items-center gap-4">
        <p className="text-sm text-foreground font-medium">New version available</p>
        <button
          onClick={() => updateServiceWorker(true)}
          className="text-sm font-semibold text-primary bg-primary/10 px-3 py-1.5 rounded hover:bg-primary/20 transition-colors"
        >
          Refresh
        </button>
      </div>
    </div>
  );
};
